module.exports = __webpack_public_path__ + "img/close1.fabe0a36.svg";